import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/view.svg';

export const IconView: IconComponent = props => <Icon {...props} src={src} />;
